<template>
  <ValidationObserver>
    <div v-bind:id="'work-' + index">
      <v-card color="grey lighten-5">
        <v-card-text>
          <v-form>
            <v-layout row wrap>
              <v-flex xs12 sm6 md6 lg6 xl6 pb-0>
                <ValidationProvider name="poste" rules="max:64">
                  <v-text-field
                    slot-scope="{
                                errors,
                                valid
                                }"
                    :error-messages="errors"
                    :success="valid"
                    label="Poste:"
                    v-model="item.title"
                    v-on:blur="$emit('update-item', item.id, item)"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-flex>

              <v-flex xs12 sm6 md6 lg6 xl6 pb-0>
                <ValidationProvider name="entreprise" rules="max:64">
                  <v-text-field
                    slot-scope="{
                                errors,
                                valid
                                }"
                    :error-messages="errors"
                    :success="valid"
                    label="Entreprise:"
                    v-model="item.institution"
                    v-on:blur="$emit('update-item', item.id, item)"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-flex>

              <v-flex xs12 sm6 md6 lg6 xl6 py-0>
                <ValidationProvider name="pays" rules="max:32">
                  <v-text-field
                    slot-scope="{
                                errors,
                                valid
                                }"
                    :error-messages="errors"
                    :success="valid"
                    label="Pays:"
                    v-model="item.country"
                    v-on:blur="$emit('update-item', item.id, item)"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-flex>

              <v-flex xs12 sm6 md6 lg6 xl6 py-0>
                <ValidationProvider name="ville" rules="max:32">
                  <v-text-field
                    slot-scope="{
                                errors,
                                valid
                                }"
                    :error-messages="errors"
                    :success="valid"
                    label="Ville:"
                    v-model="item.city"
                    v-on:blur="$emit('update-item', item.id, item)"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-flex>

              <v-flex xs6 sm3 md3 lg3 xl3 py-0>
                <ValidationProvider name="année de début" rules="numeric">
                  <v-select
                    slot-scope="{
                                errors,
                                valid
                                }"
                    :error-messages="errors"
                    :success="valid"
                    label="Année de début:"
                    v-model="item.start_year"
                    :items="date_year_options"
                    item-text="text"
                    item-value="value"
                    v-on:blur="$emit('update-item', item.id, item)"
                  >
                  </v-select>
                </ValidationProvider>
              </v-flex>

              <v-flex xs6 sm3 md3 lg3 xl3 py-0>
                <ValidationProvider name="mois de début" rules="numeric">
                  <v-select
                    slot-scope="{
                                errors,
                                valid
                                }"
                    :error-messages="errors"
                    :success="valid"
                    label="Mois de début:"
                    v-model="item.start_month"
                    :items="date_month_options"
                    item-text="text"
                    item-value="value"
                    v-on:blur="$emit('update-item', item.id, item)"
                  >
                  </v-select>
                </ValidationProvider>
              </v-flex>


              <v-flex v-if="item.is_current" class="col-12" xs12 sm6 md6 lg6 xl6 py-0>
                <v-text-field label="Année de fin:"
                              disabled
                              value="Présent"
                >
                </v-text-field>
              </v-flex>


              <v-flex v-else xs6 sm3 md3 lg3 xl3 py-0>
                <ValidationProvider name="année de fin" rules="numeric">
                  <v-select
                    slot-scope="{
                                errors,
                                valid
                                }"
                    :error-messages="errors"
                    :success="valid"
                    label="Année de fin"
                    v-model="item.end_year"
                    :items="date_year_options"
                    item-text="text"
                    item-value="value"
                    v-on:blur="$emit('update-item', item.id, item)"
                  >
                  </v-select>
                </ValidationProvider>
              </v-flex>

              <v-flex v-if="!item.is_current" xs6 sm3 md3 lg3 xl3 py-0>
                <ValidationProvider name="mois de fin" rules="numeric">
                  <v-select
                    slot-scope="{
                                errors,
                                valid
                                }"
                    :error-messages="errors"
                    :success="valid"
                    label="Mois de fin"
                    v-model="item.end_month"
                    :items="date_month_options  "
                    item-text="text"
                    item-value="value"
                    v-on:blur="$emit('update-item', item.id, item)"
                  >
                  </v-select>
                </ValidationProvider>
              </v-flex>

              <v-flex xs6 offset-xs6 py-0>
                <v-checkbox
                  class="my-0 py-0"
                  label="En cours"
                  v-model="item.is_current" :true-value=true :false-value=false
                  v-on:blur="$emit('update-item', item.id, item)"
                >
                </v-checkbox>
              </v-flex>


              <v-flex xs12 pt-0>
                <ValidationProvider name="commentaires" rules="max:1024">
                  <wysiwyg
                    slot-scope="{
                                errors,
                                valid
                                }"
                    :error-messages="errors"
                    :success="valid"
                    label="Développer les compétences acquises lors de votre expérience professionnelle:"
                    v-model="item.comments"
                    placeholder="Développer les compétences acquises lors de votre expérience professionnelle."
                    v-on:change="$emit('update-item', item.id, item)"
                  >
                  </wysiwyg>
                </ValidationProvider>
              </v-flex>

            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </ValidationObserver>
</template>



<script>

 import { mixin_basic } from './mixin_basic_vue.js';

 export default {
   mixins: [mixin_basic],
 }

</script>
